import { css, styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const currentPageVar = '--current-page';
export const gutterVar = '--gutter';
export const slidePaddingVar = '--slide-padding';

const slidesPerPageVar = '--slides-per-page';
export const slidesPerPageXsVar = `--slides-per-page-xs`;
export const slidesPerPageSmVar = `${slidesPerPageVar}-sm`;
export const slidesPerPageMdVar = `${slidesPerPageVar}-md`;
export const slidesPerPageLgVar = `${slidesPerPageVar}-lg`;

export const indexVar = '--index';
const nthIndexVar = '--nth-index';
export const nthIndexXsVar = '--nth-index-xs';
export const nthIndexSmVar = '--nth-index-sm';
export const nthIndexMdVar = '--nth-index-md';
export const nthIndexLgVar = '--nth-index-lg';

export const CarouselHolder = styled.div`
  position: relative;
`;

/**
 * The purpose of this div is to set `overflow: hidden` around the slider items
 * but not around the navigation.
 */
export const CarouselSliderHolder = styled.div<{ $autoHeight?: boolean }>`
  width: 100%;
  overflow-x: hidden;
  ${({ $autoHeight }) => !$autoHeight && `height: 100%;`}
`;

const gridColumnWidth = (slidesPerPageVariable: string) =>
  `calc((100% - (var(${slidesPerPageVariable}) - 1) * var(${gutterVar})) / var(${slidesPerPageVariable}))`;

export const CarouselSlider = styled.div<{ $autoHeight?: boolean }>`
  width: 100%;
  position: relative;
  transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  will-change: transform;
  transform: translateX(calc(100% * var(${currentPageVar}) * -1));

  ${({ $autoHeight }) =>
    $autoHeight
      ? css`
          display: grid;
          grid-auto-flow: column;
          grid-auto-columns: ${gridColumnWidth(slidesPerPageXsVar)};
          gap: var(${gutterVar});

          @media all and (min-width: ${cssBreakpoints.smUp}) {
            grid-auto-columns: ${gridColumnWidth(slidesPerPageSmVar)};
          }

          @media all and (min-width: ${cssBreakpoints.mdUp}) {
            grid-auto-columns: ${gridColumnWidth(slidesPerPageMdVar)};
          }

          @media all and (min-width: ${cssBreakpoints.lgUp}) {
            grid-auto-columns: ${gridColumnWidth(slidesPerPageLgVar)};
          }
        `
      : css`
          height: 100%;
          display: flex;
          flex-wrap: nowrap;
        `}
`;

export const CarouselSlide = styled.div<{ $autoHeight?: boolean }>`
  overflow: hidden;

  ${({ $autoHeight }) =>
    $autoHeight
      ? css`
          min-height: 0;
          padding: var(${slidePaddingVar});
        `
      : css`
          position: absolute;
          width: calc(
            100% / var(${slidesPerPageVar}) - (var(${slidesPerPageVar}) - 1) *
              var(${gutterVar})
          );
          height: 100%;
          left: calc(
            100% * var(${indexVar}) / var(${slidesPerPageVar}) +
              var(${gutterVar}) * var(${nthIndexVar})
          );

          ${nthIndexVar}: var(${nthIndexXsVar});
          ${slidesPerPageVar}: var(${slidesPerPageXsVar});

          @media all and (min-width: ${cssBreakpoints.smUp}) {
            ${nthIndexVar}: var(${nthIndexSmVar});
            ${slidesPerPageVar}: var(${slidesPerPageSmVar});
          }

          @media all and (min-width: ${cssBreakpoints.mdUp}) {
            ${nthIndexVar}: var(${nthIndexMdVar});
            ${slidesPerPageVar}: var(${slidesPerPageMdVar});
          }

          @media all and (min-width: ${cssBreakpoints.lgUp}) {
            ${nthIndexVar}: var(${nthIndexLgVar});
            ${slidesPerPageVar}: var(${slidesPerPageLgVar});
          }
        `}
`;
